import React, { useEffect, useRef } from "react";
import { Box, Typography, Avatar, Button } from "@mui/material";
import { styled } from "@mui/system";
import "../../styles/BotPage.css";
import DownloadIcon from "@mui/icons-material/Download";
import EmailIcon from "@mui/icons-material/Email";
import { useLocation } from 'react-router-dom';
import userImage from "../../assets/0_1-8.jpeg";

const ChatContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  height: "calc(100vh - 450px)",
  minHeight: "300px",
  overflowY: "auto",
  backgroundColor: "inherit",
  borderRadius: "10px",
  scrollbarWidth: "thin",
  "&::-webkit-scrollbar": {
    width: "4px",
  },
  "&::-webkit-scrollbar-track": {
    background: "rgba(255, 255, 255, 0.1)",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "rgba(255, 255, 255, 0.3)",
    borderRadius: "4px",
  },
});

const MessageContainer = styled(Box)(({ role }) => ({
  display: "flex",
  alignItems: "flex-start",
  marginBottom: "8px",
  flexDirection: role === "user" ? "row-reverse" : "row",
  padding: "0 8px",
}));

const MessageBubble = styled(Box)(({ role }) => ({
  maxWidth: "75%",
  padding: "8px 12px",
  borderRadius: "12px",
  backgroundColor: role === "user" ? "#007aff" : "#1c1c1c",
  color: "#fff",
  marginLeft: role === "user" ? "8px" : "4px",
  marginRight: role === "user" ? "4px" : "8px",
  boxShadow: "0px 1px 3px rgba(0,0,0,0.2)",
  wordBreak: "break-word",
  fontSize: "0.9rem",
}));

const LiveTranscript = ({
  conversation,
  downloadTranscript,
  hasTranscript,
}) => {
  const chatEndRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
    }
  }, [conversation]);

  const getAvatarSrc = (role) => {
    if (role === 'user') {
      return 'https://cdn.icon-icons.com/icons2/1378/PNG/512/avatardefault_92824.png';
    } else if (location.pathname === '/career-coach-assistant-voice-bot') {
      return userImage;
    } else {
      return 'https://img.freepik.com/premium-photo/woman-robot-with-mobile-her-hand_795294-16.jpg';
    }
  };

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Typography
        variant="body2"
        sx={{
          textAlign: "center",
          color: "#ffffff",
          fontSize: "14px",
          marginBottom: "12px",
        }}
      >
        Live Transcript
      </Typography>
      <ChatContainer>
        {conversation?.map((message, index) => (
          <MessageContainer key={index} role={message.role}>
            <Avatar
              alt={message.role}
              src={getAvatarSrc(message.role)}
              sx={{ width: 32, height: 32 }}
            />
            <MessageBubble role={message.role}>
              <Typography variant="body2">{message.content}</Typography>
            </MessageBubble>
          </MessageContainer>
        ))}
        <div ref={chatEndRef} style={{ float: "left", clear: "both" }} />
      </ChatContainer>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-evenly",
          marginTop: "12px",
          gap: 2,
        }}
      >
        <Button
          variant="contained"
          onClick={downloadTranscript}
          disabled={!hasTranscript}
          id="download-button"
          startIcon={<DownloadIcon />}
          size="small"
        >
          Download
        </Button>
        <Button
          variant="contained"
          disabled={!hasTranscript}
          id="email-button"
          startIcon={<EmailIcon />}
          size="small"
        >
          Email
        </Button>
      </Box>
    </Box>
  );
};

export default LiveTranscript;
